var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 281"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 7",
    x1: 10.5,
    y1: -2.18557e-8,
    x2: 10.5,
    y2: 20,
    stroke: "#667085"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 8",
    x1: 20,
    y1: 10.5,
    x2: -4.37114e-8,
    y2: 10.5,
    stroke: "#667085"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.20a8f0e975f997df00602ad68f08d8ec365fde75d1019ccc53a93c1cda03d716.svg";
export { ForwardRef as ReactComponent };